import Controller from '@ember/controller';
import { action, computed, get, set, setProperties } from '@ember/object';
import { service } from '@ember/service';
import { pledgeFrequencyLabels } from 'donor-elf-web/lib/pledge-utils';
import { task } from 'ember-concurrency';

export default Controller.extend({
  fundsService: service(),
  router: service(),

  error: null,

  reset() {
    setProperties(this, {
      error: null,
    });
  },

  fundOptions: computed('model.funds.@each.id', function () {
    return get(this, 'model.funds').map((fund) => {
      return { val: get(fund, 'id'), label: get(fund, 'name') };
    });
  }),

  frequencyOptions: computed(function () {
    let options = [];
    Object.keys(pledgeFrequencyLabels).forEach((key) => {
      // not dealing with one time frequencies yet
      if (
        pledgeFrequencyLabels[key] !== 'Weekly' &&
        pledgeFrequencyLabels[key] !== 'One Time'
      ) {
        options.push({
          val: Number(key),
          label: pledgeFrequencyLabels[key],
        });
      }
    });
    return options;
  }),

  save: task(function* () {
    let changeset = get(this, 'model.changeset');
    yield changeset.validate();
    if (get(changeset, 'isValid')) {
      yield this.fundsService.confirmValidFundToken();
      try {
        yield changeset.save();
        this.send('refreshDonorRoute');
        this.router.transitionTo('organization.donors.donor');
      } catch (error) {
        if (get(this, 'model.record.errors.length') > 0) {
          get(this, 'model.record.errors').forEach(({ attribute, message }) => {
            changeset.pushErrors(attribute, message);
          });
        } else {
          set(this, 'error', error);
        }
      }
    }
  }).drop(),

  handleFrequencyChanged: action(function (/* newFrequency */) {
    set(this, 'model.changeset.endDateMonths', '12');
  }),
});
